<template>
  <multiselect
    v-model="currentLanguage"
    :allow-empty="false"
    :options="supportedLanguages"
    tagPlaceholder=""
    placeholder=""
    selectLabel=""
    deselectLabel=""
    selectedLabel=""
    :custom-label="customLabel"
    :searchable="false"
  />
</template>

<script>
import { Trans } from "@/plugins/Translation";
import Multiselect from "vue-multiselect";

export default {
  name: "TheLanguageSwitcher",
  components: {
    Multiselect
  },
  computed: {
    supportedLanguages() {
      return Trans.supportedLanguages;
    },
    currentLanguage: {
      get() {
        return Trans.currentLanguage;
      },
      set(newLocale) {
        // drop a cookie
        // this.$cookies.set("language", newLocale, "1y");

        let currentLocale = Trans.currentLanguage;

        let path = window.location.pathname;
        let newPath = "";
        let explodedPath = path.split("/");

        // loop and build new path
        explodedPath.map(path => {
          // do nothing if blank
          if (path === "") {
            return false;
          }

          // replace old locale with new
          if (path === currentLocale) {
            path = newLocale;
          }

          newPath += `/${path}`;
        });

        window.location.href = `${window.location.origin}${newPath}`;
      }
    }
  },
  methods: {
    customLabel(option) {
      return this.$t(option);
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.LanguageSwitcher {
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/TheLanguageSwitcher.vue